import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
	closeBtn: {
		position: 'absolute',
		right: theme.spacing(2),
		top: 0,
		bottom: 0
	}
}));

export default useStyles;
